import { tv } from 'tailwind-variants';

export const iconButtonStyle = tv({
  slots: {
    container: [
      'group inline-flex shrink-0 items-center justify-center rounded-lg',
      'transition-colors cursor-pointer',
      'outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-green-500',
    ],
    icon: [],
  },

  variants: {
    size: {
      sm: {
        container: ['w-8 h-8'],
        icon: ['w-4 h-4'],
      },
      md: {
        container: ['w-10 h-10'],
        icon: ['w-4 h-4'],
      },
      lg: {
        container: ['w-12 h-12'],
        icon: ['w-4 h-4'],
      },
    },
    disabled: {
      true: {
        container: ['pointer-events-none'],
        icon: ['text-gray-400'],
      },
      false: {
        container: ['hover:bg-gray-100 active:bg-gray-200'],
        icon: ['text-gray-700 group-active:text-gray-900'],
      },
    },
  },

  defaultVariants: {
    size: 'sm',
    disabled: false,
  },
});
